export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-06.b901e27a.svg";